import React from "react";

const HighlightItem = ({ title, row }) => (
  <article className="anthropometry-detailed-progress__muscle-analysis__item">
    <p className="anthropometry-detailed-progress__muscle-analysis__item__label">
      {title}
    </p>
    <div className="anthropometry-detailed-progress__muscle-analysis__item__content">
      <strong>{row.regionLabel}</strong>
      <span
        className={`anthropometry-detailed-progress__variation anthropometry-detailed-progress__variation--${row.trend}`}
      >
        {row.variationLabel}
      </span>
    </div>
  </article>
);

const MuscleGroupAnalysisPanel = ({ highlights }) => (
  <section className="anthropometry-detailed-progress__card anthropometry-detailed-progress__card--muscle-analysis">
    <div className="anthropometry-detailed-progress__card__header">
      <div>
        <h2>Análise por grupo muscular</h2>
      </div>
    </div>

    {highlights ? (
      <div className="anthropometry-detailed-progress__muscle-analysis__items">
        <HighlightItem title="Melhor evolução" row={highlights.best} />
        <HighlightItem title="Pior evolução" row={highlights.worst} />
      </div>
    ) : (
      <div className="anthropometry-detailed-progress__panel-empty anthropometry-detailed-progress__panel-empty--compact">
        <p>Não há variação suficiente no período selecionado.</p>
      </div>
    )}
  </section>
);

export default MuscleGroupAnalysisPanel;
